import {useMemo} from 'react'
import {UIGamePlayerInfoSectionContentPiecesProps} from '../../UIGamePlayerInfo'
import {PlayerColor} from '@colonist/game-states'
import {useMechanicValidatorSettlement} from '../../../store/selectors/useMechanicValidatorSettlement'
import {useMechanicValidatorRoad} from '../../../store/selectors/useMechanicValidatorRoad'
import {useMechanicValidatorCity} from '../../../store/selectors/useMechanicValidatorCity'
import {useMechanicValidatorShip} from '../../../store/selectors/useMechanicValidatorShip'
import {useMechanicValidatorCityWall} from '../../../store/selectors/useMechanicValidatorCityWall'

export const usePlayerInfoSectionContentPiecesProps = (playerColor: PlayerColor) => {
    const roadValidator = useMechanicValidatorRoad()
    const roadCount = roadValidator?.getRoadPlayerState(playerColor).bankRoadAmount
    const settlementValidator = useMechanicValidatorSettlement()
    const settlementCount = settlementValidator?.getSettlementPlayerState(playerColor).bankSettlementAmount
    const cityValidator = useMechanicValidatorCity()
    const cityCount = cityValidator?.getCityPlayerState(playerColor).bankCityAmount
    const shipValidator = useMechanicValidatorShip()
    const shipCount = shipValidator?.getShipPlayerState(playerColor).bankShipAmount
    const cityWallValidator = useMechanicValidatorCityWall()
    const cityWallCount = cityWallValidator?.getCityWallPlayerState(playerColor).bankCityWallAmount

    return useMemo<UIGamePlayerInfoSectionContentPiecesProps>(() => ({
        playerColor: playerColor,
        roadCount: roadCount,
        settlementCount: settlementCount,
        cityCount: cityCount,
        shipCount: shipCount,
        cityWallCount: cityWallCount,
    }), [playerColor, roadCount, settlementCount, cityCount, shipCount, cityWallCount])
}
